/**
 * 住所検索リクエスト
 */
export class AddressRequest {
	public postcode: string = null;		// 郵便番号
}
